// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-content[data-v-472be1b5] {
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.label-content .content[data-v-472be1b5] {
  width: 100%;
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/Gclqd.vue","webpack://./Gclqd.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ACAF;ADLA;EAOI,WAAA;EACA,OAAA;ACCJ","sourcesContent":["\n.label-content {\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  .content {\n    width: 100%;\n    flex: 1;\n  }\n}\n",".label-content {\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.label-content .content {\n  width: 100%;\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
